import type { ListProduct } from '@/queries/Products';

export default function getHasSelectedWarranty(
  sku: string,
  warranty: ListProduct | undefined,
): boolean {
  if (!warranty) return false;
  return warranty.variants.some((v) => v.sku === sku);
}
